import { PageBreadcrumbItem } from "components/common/PageBreadcrumb";

export const versoesBreadcrumbItems = [
  {
    label: "Home",
    url: "/",
  },
  {
    label: "Admin",
    url: "/admin",
  },
  {
    label: "Versões",
    url: "/admin/versoes",
  },
];

export const editarVersaoBreadcrumbItems = (
  codigo?: number
): PageBreadcrumbItem[] => [
  {
    label: "Home",
    url: "/",
  },
  {
    label: "Admin",
    url: "/admin",
  },
  {
    label: "Versões",
    url: "/admin/versoes",
  },
  {
    label: codigo?.toString() ?? "Novo",
    active: true,
  },
];
